import React from 'react';

import NonAuthSurveyPage from 'components/NonAuthSurveyPage';
import useStyles from './useStyles';

const EmbedLayout = () => {
  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <main className={classes.content}>
        <NonAuthSurveyPage removeQuoteBox />
      </main>
    </div>
  );
};

export default EmbedLayout;



// WEBPACK FOOTER //
// ./src/components/EmbedSurveyPage/EmbedSurveyPage.js